import styled from 'styled-components';
import { device } from 'commons';

export const Wrapper = styled.header`
  width: 100%;
  display: flex;
  gap: 16px;
  padding: 16px 48px;
  background-color: ${({ theme }) => theme.neutral_100};
  box-shadow: 0px 4px 8px ${({ theme }) => theme.neutral_200};
  z-index: 1;

  @media (max-width: ${device.tablet}px) {
    padding: 16px 28px;
  }
`;
